import { SkinActionTypes } from '../action-types/skinTypes';
import { SkinActions } from '../actions/skinTypes';
import { Dispatch } from 'redux';

export const setSkin = (skin: SkinState) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_SKIN,
      payload: skin,
    });
  };
};

export const setGlobalConfig = (value: {
  showLogo: boolean;
  primary: {
    defaultBackground: string;
    activeBackground: string;
    text: string;
  };
  secondary: {
    promotion: string;
    promotion2: string;
    error: string;
  };
}) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_GLOBAL_CONFIG,
      payload: value,
    });
  };
};

export const setHeaderConfig = (value: { background: string; text: string }) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_HEADER_CONFIG,
      payload: value,
    });
  };
};

export const setNavigationConfig = (value: {
  background: string;
  activeBackground: string;
  text: string;
}) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_NAVIGATION_CONFIG,
      payload: value,
    });
  };
};

export const setButtonNavConfig = (value: {
  default: { background: string; inactiveBackground: string; text: string };
  active: { background: string; inactiveBackground: string; text: string };
}) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_BUTTON_NAV_CONFIG,
      payload: value,
    });
  };
};

export const setComponentConfig = (value: {
  primary: { color1: string; color2: string; color3: string };
  secondary: { color1: string; color2: string; color3: string };
}) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_COMPONENT_CONFIG,
      payload: value,
    });
  };
};

export const setFooterConfig = (value: {
  default: { background: string; text: string; link: string };
  active: { background: string; text: string; link: string };
}) => {
  return (dispatch: Dispatch<SkinActions>) => {
    dispatch({
      type: SkinActionTypes.SET_FOOTER_CONFIG,
      payload: value,
    });
  };
};
